

import PageOne from "./PageOne/PageOne";
import PageTwo from "./PageTwo/PageTwo";
import PageThree from "./PageThree/PageThree";
import PageFour from "./PageFour/PageFour";
import React, { useState, useEffect } from "react";
import MultiStepProgressBar from "./MultiStepProgressBar/MultiStepProgressBar";
import Header from '../Header/Header'
import Footer from "../Footer/Footer";
import { Col, Container, Row } from "react-bootstrap";
import { AvForm, AvGroup, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import { Button, FormGroup, Label, Input } from 'reactstrap';
import { connect } from "react-redux"
// import { loginUser, apiError, socialLogin } from "../../store/actions"
import { loginSuccess } from "../store/actions"
import { withRouter, Link } from "react-router-dom"
import PropTypes from 'prop-types'
import { post } from "../helpers/api_helper";
import statecity1 from '../assets/jsons/statecity1.json'
function QuickAdd(props) {
  const [page, setPage] = useState("pageone");
  const [loginpage, setLoginpage] = useState(false);
  const [repage, setRepage] = useState(false);
  const [registerForm, setRegisterForm] = useState(false);


  const { user } = props;


  const [selectedState, setSelectedState] = useState("");
  const [cityOptions, setCityOptions] = useState([]);
  const [sateData, setStateData] = useState([]);
  const [setpone, setStepone] = useState(null);


  useEffect(() => {
    // console.log('statecity1',statecity1);
    setStateData(statecity1)
  }, [sateData])

  useEffect(() => {
    if (selectedState) {
      const city = sateData.findIndex(x => x.name == selectedState);
      // console.log('city',city);
      // let cities = [];
      // city.map((item)=>{
      //   cities.push(item);
      // });
      setCityOptions(sateData[city]?.cities);
      // console.log('cities',city);
    }
  }, [selectedState]);



  useEffect(() => {
    getStep();

  }, []);

  useEffect(() => {
    //  console.log('user on login page',user);
  }, [user]);

  const getStep = async () => {
    var data = await localStorage.getItem("authUser");

    if (data) {
      data = JSON.parse(data);
      setStepone(data?.step);
    }

  }

  const nextPage = (page) => {
    setPage(page);
  };





  const handleValidSubmit = (event, values) => {

    // console.log('values',values)
    // props.loginUser(values, props.history);
    post('/login', values)
      .then((json => {
        // console.log('response data', json);
        if (json?.exist == false) {
          if (json?.statusCode == 200) {
            if (json?.message == "OTP Sent to your mailbox !") {
              localStorage.setItem('email', values.email);
              props.history.push("/register");
            } else {
              // setRepage(true);
              var opprtunity_path = localStorage.getItem('opprtunity');
              // console.log('opprtunity_path',opprtunity_path);
              if (opprtunity_path) {
                props.history.push("/opportunity/" + opprtunity_path);

              } else {
                props.history.push("/");
              }
            }


          } else {
            // setRepage(false);
            // setLoginpage(true);
            // setRepage(true);
            var opprtunity_path = localStorage.getItem('opprtunity');
            // console.log('opprtunity_path',opprtunity_path);
            if (opprtunity_path) {
              props.history.push("/opportunity/" + opprtunity_path);

            } else {
              props.history.push("/");
            }

          }


        } else {
          if (json?.statusCode == 200) {

            // props.history.push("/login");
            setLoginpage(true);
            if (json?.message == "Password is Required!") {
              props.history.push("/login");
            } else {
              props.history.push("/");
              localStorage.setItem("authUser", JSON.stringify(json?.data));
              props?.loginSuccess(json?.data);
            }

          }

        }
      }))


  }



  return (
    <>
      <Header />

      <div className="auth-section login-section">
        <Container fluid>
          <Row className={user?.step == 1 ? 'login-box active' : 'login-box'}>
            <Col lg={12} md={12}>
              <AvForm
                onValidSubmit={(e, v) => {
                  handleValidSubmit(e, v)
                }}
              >
                <Row>
                  <Col lg={4} md={4}>
                    <AvField type="text" name="name" label="Full Name" required />
                  </Col>
                  <Col lg={4} md={4}>
                    <AvField type="email" name="email" label="Email" required />
                  </Col>
                  <Col lg={4} md={4}>
                    <AvField type="text" name="mobile" label="Mobile" required />
                  </Col>
                  <Col lg={4} md={4}>
                    <AvField type="text" name="registerNo" label="Register No" required />
                  </Col>
                  <Col md={4} sm={6}>
                    <AvField type="select" name="state"

                      onChange={e => setSelectedState(e.target.value)}
                      label="Select State" required>
                      <option>Select State</option>
                      {
                        sateData.map((item) =>
                          <>
                            <option value={item?.name}>{item?.name}</option>
                          </>
                        )

                      }

                    </AvField>
                  </Col>
                  <Col md={4} sm={6}>
                    <AvField type="select" name="city" label="Select City" required>
                      <option>Select City</option>
                      {
                        cityOptions.map((item) =>
                          <>
                            <option value={item?.name}>{item?.name}</option>
                          </>
                        )
                      }
                    </AvField>
                  </Col>
                </Row>
                <FormGroup>
                  <Button type="submit" className="common-btn">Submit</Button>
                </FormGroup>
              </AvForm>

            </Col>

          </Row>
        </Container>
      </div>
      <Footer />
    </>
  );
}

const mapStateToProps = state => {
  //   const { user } = state.Login
  //   return { user }
}

export default withRouter(
  connect(mapStateToProps, { loginSuccess })(QuickAdd)
)


// Login.propTypes = {
//   history: PropTypes.object,
//   loginSuccess: PropTypes.func
// }